export default "__VITE_ASSET__6UqvSBLx__"